export default __webpack_public_path__ + "static/media/QRcode.6d826ca5.png";